import { COMPANY_DEFAULT_FLOOD_PRODUCT_OPTION } from 'app/shared/components/loanManagement/loanActionsGroup/LoanActionFloodServiceRow.constants';

export const COMMENTS_FIELD_NAME = 'comments';
export const COMMENTS_MAX_LENGTH = 1000;
export const COMMENTS_ROWS = 4;

export const INITIAL_FORM_STATE = { product: COMPANY_DEFAULT_FLOOD_PRODUCT_OPTION };
